import { t } from '@lingui/core/macro'

export enum Country {
    AU = 'AU',
    AT = 'AT',
    AZ = 'AZ',
    AL = 'AL',
    DZ = 'DZ',
    AO = 'AO',
    AD = 'AD',
    AR = 'AR',
    AM = 'AM',
    AF = 'AF',
    BS = 'BS',
    BD = 'BD',
    BB = 'BB',
    BH = 'BH',
    BZ = 'BZ',
    BY = 'BY',
    BE = 'BE',
    BJ = 'BJ',
    BG = 'BG',
    BO = 'BO',
    BA = 'BA',
    BW = 'BW',
    BR = 'BR',
    BN = 'BN',
    BF = 'BF',
    BI = 'BI',
    BT = 'BT',
    VU = 'VU',
    VA = 'VA',
    GB = 'GB',
    HU = 'HU',
    VE = 'VE',
    VN = 'VN',
    GA = 'GA',
    HT = 'HT',
    GY = 'GY',
    GM = 'GM',
    GH = 'GH',
    GT = 'GT',
    GN = 'GN',
    GW = 'GW',
    DE = 'DE',
    HN = 'HN',
    GD = 'GD',
    GR = 'GR',
    GE = 'GE',
    DK = 'DK',
    DJ = 'DJ',
    DM = 'DM',
    DO = 'DO',
    EG = 'EG',
    ZM = 'ZM',
    ZW = 'ZW',
    IL = 'IL',
    IN = 'IN',
    ID = 'ID',
    JO = 'JO',
    IQ = 'IQ',
    IR = 'IR',
    IE = 'IE',
    IS = 'IS',
    ES = 'ES',
    IT = 'IT',
    YE = 'YE',
    CV = 'CV',
    KZ = 'KZ',
    KH = 'KH',
    CM = 'CM',
    CA = 'CA',
    QA = 'QA',
    KE = 'KE',
    CY = 'CY',
    KG = 'KG',
    CN = 'CN',
    CO = 'CO',
    KM = 'KM',
    CG = 'CG',
    CR = 'CR',
    CI = 'CI',
    CU = 'CU',
    KW = 'KW',
    LA = 'LA',
    LV = 'LV',
    LS = 'LS',
    LR = 'LR',
    LB = 'LB',
    LY = 'LY',
    LT = 'LT',
    LI = 'LI',
    LU = 'LU',
    MU = 'MU',
    MR = 'MR',
    MG = 'MG',
    MW = 'MW',
    MY = 'MY',
    ML = 'ML',
    MV = 'MV',
    MT = 'MT',
    MA = 'MA',
    MX = 'MX',
    MZ = 'MZ',
    MD = 'MD',
    MC = 'MC',
    MN = 'MN',
    MM = 'MM',
    NA = 'NA',
    NP = 'NP',
    NE = 'NE',
    NG = 'NG',
    NL = 'NL',
    NI = 'NI',
    NZ = 'NZ',
    NO = 'NO',
    AE = 'AE',
    OM = 'OM',
    PK = 'PK',
    PA = 'PA',
    PG = 'PG',
    PY = 'PY',
    PE = 'PE',
    PL = 'PL',
    PT = 'PT',
    RU = 'RU',
    RW = 'RW',
    RO = 'RO',
    SV = 'SV',
    WS = 'WS',
    SM = 'SM',
    SA = 'SA',
    MK = 'MK',
    SC = 'SC',
    SN = 'SN',
    RS = 'RS',
    SG = 'SG',
    SY = 'SY',
    SK = 'SK',
    SI = 'SI',
    SO = 'SO',
    SD = 'SD',
    SR = 'SR',
    US = 'US',
    SL = 'SL',
    TJ = 'TJ',
    TH = 'TH',
    TZ = 'TZ',
    TG = 'TG',
    TO = 'TO',
    TT = 'TT',
    TV = 'TV',
    TN = 'TN',
    TM = 'TM',
    TR = 'TR',
    UG = 'UG',
    UZ = 'UZ',
    UA = 'UA',
    UY = 'UY',
    FJ = 'FJ',
    PH = 'PH',
    FI = 'FI',
    FR = 'FR',
    HR = 'HR',
    CF = 'CF',
    TD = 'TD',
    ME = 'ME',
    CZ = 'CZ',
    CL = 'CL',
    CH = 'CH',
    SE = 'SE',
    LK = 'LK',
    EC = 'EC',
    GQ = 'GQ',
    ER = 'ER',
    EE = 'EE',
    ET = 'ET',
    ZA = 'ZA',
    KR = 'KR',
    SS = 'SS',
    JM = 'JM',
    JP = 'JP',
}

export interface CountryName {
    country: Country
    name: string
}

export const getCountryNames = () => [
    { name: t`Австралия`, country: Country.AU },
    { name: t`Австрия`, country: Country.AT },
    { name: t`Азербайджан`, country: Country.AZ },
    { name: t`Албания`, country: Country.AL },
    { name: t`Алжир`, country: Country.DZ },
    { name: t`Ангола`, country: Country.AO },
    { name: t`Андорра`, country: Country.AD },
    { name: t`Аргентина`, country: Country.AR },
    { name: t`Армения`, country: Country.AM },
    { name: t`Афганистан`, country: Country.AF },
    { name: t`Багамы`, country: Country.BS },
    { name: t`Бангладеш`, country: Country.BD },
    { name: t`Барбадос`, country: Country.BB },
    { name: t`Бахрейн`, country: Country.BH },
    { name: t`Белиз`, country: Country.BZ },
    { name: t`Беларусь`, country: Country.BY },
    { name: t`Бельгия`, country: Country.BE },
    { name: t`Бенин`, country: Country.BJ },
    { name: t`Болгария`, country: Country.BG },
    { name: t`Боливия`, country: Country.BO },
    { name: t`Босния и Герцеговина`, country: Country.BA },
    { name: t`Ботсвана`, country: Country.BW },
    { name: t`Бразилия`, country: Country.BR },
    { name: t`Бруней`, country: Country.BN },
    { name: t`Буркина-Фасо`, country: Country.BF },
    { name: t`Бурundi`, country: Country.BI },
    { name: t`Бутан`, country: Country.BT },
    { name: t`Вануату`, country: Country.VU },
    { name: t`Ватикан`, country: Country.VA },
    { name: t`Великобритания`, country: Country.GB },
    { name: t`Венгрия`, country: Country.HU },
    { name: t`Венесуэла`, country: Country.VE },
    { name: t`Вьетнам`, country: Country.VN },
    { name: t`Габон`, country: Country.GA },
    { name: t`Гаити`, country: Country.HT },
    { name: t`Гайана`, country: Country.GY },
    { name: t`Гамбия`, country: Country.GM },
    { name: t`Гана`, country: Country.GH },
    { name: t`Гватемала`, country: Country.GT },
    { name: t`Гвинея`, country: Country.GN },
    { name: t`Гвинея-Бисау`, country: Country.GW },
    { name: t`Германия`, country: Country.DE },
    { name: t`Гондурас`, country: Country.HN },
    { name: t`Гренада`, country: Country.GD },
    { name: t`Греция`, country: Country.GR },
    { name: t`Грузия`, country: Country.GE },
    { name: t`Дания`, country: Country.DK },
    { name: t`Джибути`, country: Country.DJ },
    { name: t`Доминика`, country: Country.DM },
    { name: t`Доминиканская Республика`, country: Country.DO },
    { name: t`Египет`, country: Country.EG },
    { name: t`Замбия`, country: Country.ZM },
    { name: t`Зимбабве`, country: Country.ZW },
    { name: t`Израиль`, country: Country.IL },
    { name: t`Индия`, country: Country.IN },
    { name: t`Индонезия`, country: Country.ID },
    { name: t`Иордания`, country: Country.JO },
    { name: t`Ирак`, country: Country.IQ },
    { name: t`Иран`, country: Country.IR },
    { name: t`Ирландия`, country: Country.IE },
    { name: t`Исландия`, country: Country.IS },
    { name: t`Испания`, country: Country.ES },
    { name: t`Италия`, country: Country.IT },
    { name: t`Йемен`, country: Country.YE },
    { name: t`Кабо-Верде`, country: Country.CV },
    { name: t`Казахстан`, country: Country.KZ },
    { name: t`Камбоджа`, country: Country.KH },
    { name: t`Камерун`, country: Country.CM },
    { name: t`Канада`, country: Country.CA },
    { name: t`Катар`, country: Country.QA },
    { name: t`Кения`, country: Country.KE },
    { name: t`Кипр`, country: Country.CY },
    { name: t`Киргизия`, country: Country.KG },
    { name: t`Китай`, country: Country.CN },
    { name: t`Колумбия`, country: Country.CO },
    { name: t`Коморы`, country: Country.KM },
    { name: t`Конго`, country: Country.CG },
    { name: t`Коста-Рика`, country: Country.CR },
    { name: t`Кот-д'Ивуар`, country: Country.CI },
    { name: t`Куба`, country: Country.CU },
    { name: t`Кувейт`, country: Country.KW },
    { name: t`Лаос`, country: Country.LA },
    { name: t`Латвия`, country: Country.LV },
    { name: t`Лесото`, country: Country.LS },
    { name: t`Либерия`, country: Country.LR },
    { name: t`Ливан`, country: Country.LB },
    { name: t`Ливия`, country: Country.LY },
    { name: t`Литва`, country: Country.LT },
    { name: t`Лихтенштейн`, country: Country.LI },
    { name: t`Люксембург`, country: Country.LU },
    { name: t`Маврикий`, country: Country.MU },
    { name: t`Мавритания`, country: Country.MR },
    { name: t`Мадагаскар`, country: Country.MG },
    { name: t`Малави`, country: Country.MW },
    { name: t`Малайзия`, country: Country.MY },
    { name: t`Мали`, country: Country.ML },
    { name: t`Мальдивы`, country: Country.MV },
    { name: t`Мальта`, country: Country.MT },
    { name: t`Марокко`, country: Country.MA },
    { name: t`Мексика`, country: Country.MX },
    { name: t`Мозамбик`, country: Country.MZ },
    { name: t`Молдова`, country: Country.MD },
    { name: t`Монако`, country: Country.MC },
    { name: t`Монголия`, country: Country.MN },
    { name: t`Мьянма`, country: Country.MM },
    { name: t`Намибия`, country: Country.NA },
    { name: t`Непал`, country: Country.NP },
    { name: t`Нигер`, country: Country.NE },
    { name: t`Нигерия`, country: Country.NG },
    { name: t`Нидерланды`, country: Country.NL },
    { name: t`Никарагуа`, country: Country.NI },
    { name: t`Новая Зеландия`, country: Country.NZ },
    { name: t`Норвегия`, country: Country.NO },
    { name: t`ОАЭ`, country: Country.AE },
    { name: t`Оман`, country: Country.OM },
    { name: t`Пакистан`, country: Country.PK },
    { name: t`Панама`, country: Country.PA },
    { name: t`Папуа — Новая Гвинея`, country: Country.PG },
    { name: t`Парагвай`, country: Country.PY },
    { name: t`Перу`, country: Country.PE },
    { name: t`Польша`, country: Country.PL },
    { name: t`Португалия`, country: Country.PT },
    { name: t`Россия`, country: Country.RU },
    { name: t`Руанда`, country: Country.RW },
    { name: t`Румыния`, country: Country.RO },
    { name: t`Сальвадор`, country: Country.SV },
    { name: t`Самоа`, country: Country.WS },
    { name: t`Сан-Марино`, country: Country.SM },
    { name: t`Саудовская Аравия`, country: Country.SA },
    { name: t`Северная Македония`, country: Country.MK },
    { name: t`Сейшелы`, country: Country.SC },
    { name: t`Сенегал`, country: Country.SN },
    { name: t`Сербия`, country: Country.RS },
    { name: t`Сингапур`, country: Country.SG },
    { name: t`Сирия`, country: Country.SY },
    { name: t`Словакия`, country: Country.SK },
    { name: t`Словения`, country: Country.SI },
    { name: t`Сомали`, country: Country.SO },
    { name: t`Судан`, country: Country.SD },
    { name: t`Суринам`, country: Country.SR },
    { name: t`США`, country: Country.US },
    { name: t`Сьерра-Леоне`, country: Country.SL },
    { name: t`Таджикистан`, country: Country.TJ },
    { name: t`Таиланд`, country: Country.TH },
    { name: t`Танзания`, country: Country.TZ },
    { name: t`Того`, country: Country.TG },
    { name: t`Тонга`, country: Country.TO },
    { name: t`Тринидад и Тобаго`, country: Country.TT },
    { name: t`Тувалу`, country: Country.TV },
    { name: t`Тунис`, country: Country.TN },
    { name: t`Туркменистан`, country: Country.TM },
    { name: t`Турция`, country: Country.TR },
    { name: t`Уганда`, country: Country.UG },
    { name: t`Узбекистан`, country: Country.UZ },
    { name: t`Украина`, country: Country.UA },
    { name: t`Уругвай`, country: Country.UY },
    { name: t`Фиджи`, country: Country.FJ },
    { name: t`Филиппины`, country: Country.PH },
    { name: t`Финляндия`, country: Country.FI },
    { name: t`Франция`, country: Country.FR },
    { name: t`Хорватия`, country: Country.HR },
    { name: t`ЦАР`, country: Country.CF },
    { name: t`Чад`, country: Country.TD },
    { name: t`Черногория`, country: Country.ME },
    { name: t`Чехия`, country: Country.CZ },
    { name: t`Чили`, country: Country.CL },
    { name: t`Швейцария`, country: Country.CH },
    { name: t`Швеция`, country: Country.SE },
    { name: t`Шри-Ланка`, country: Country.LK },
    { name: t`Эквадор`, country: Country.EC },
    { name: t`Экваториальная Гвинея`, country: Country.GQ },
    { name: t`Эритрея`, country: Country.ER },
    { name: t`Эстония`, country: Country.EE },
    { name: t`Эфиопия`, country: Country.ET },
    { name: t`ЮАР`, country: Country.ZA },
    { name: t`Южная Корея`, country: Country.KR },
    { name: t`Южный Судан`, country: Country.SS },
    { name: t`Ямайка`, country: Country.JM },
    { name: t`Япония`, country: Country.JP },
] as CountryName[]
